import { render, staticRenderFns } from "./CampaignEdit.vue?vue&type=template&id=bf6f731c"
import script from "./CampaignEdit.vue?vue&type=script&lang=js"
export * from "./CampaignEdit.vue?vue&type=script&lang=js"
import style0 from "./CampaignEdit.vue?vue&type=style&index=0&id=bf6f731c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports